import React from "react";
import { Tooltip } from "@mui/material";
import { formatDisplayDateTime } from "../utils/formatters";
import "./PlanStatus.css";

/**
 * Shared "Plan Status" column for the MaterialReactTable listings. Rows are
 * expected to carry `is_expired` and the original API item as `raw`.
 */
export const planStatusColumn = {
  accessorFn: (row) => (row.is_expired ? "Expired" : "Active"),
  id: "plan_status",
  header: "Plan Status",
  size: 115,
  Cell: ({ row }) => {
    const expired = row.original.is_expired;
    const expiresOn = row.original.raw?.expires_on;
    return (
      <Tooltip
        title={
          expired
            ? `Expired on ${formatDisplayDateTime(expiresOn)}`
            : expiresOn
              ? `Renews or expires on ${formatDisplayDateTime(expiresOn)}`
              : "No expiry recorded"
        }
      >
        <span className={expired ? "plan-status-expired" : "plan-status-active"}>
          {expired ? "Expired" : "Active"}
        </span>
      </Tooltip>
    );
  },
};

/** Extra row class for a lapsed plan, so it reads as excluded from the counts. */
export const expiredRowClass = (row) =>
  row.original.is_expired ? "expired-plan-row" : "";
